<template>
  <div class="dictionary-base">
    <data-table ref="dataTable" :option="option">
      <template slot="mySlot">
        <div>
          <ColorPicker v-model="color" @change="changeColor" />
        </div>
      </template>
    </data-table>
  </div>
</template>

<script>
import { DataTable } from "@/components/dataTable";
import ColorPicker from "@/components/tools/color-picker";

export default {
  components: {
    DataTable,
    ColorPicker
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      option: {},
      apiOptions: {},
      color: "",
      extendData: ""
    };
  },
  created() {
    const _this = this;
    _this.extendData = _this.data.treeSelect;

    _this.apiOptions = {
      api: "MaintenancePage_List",
      params: { Type: _this.data.treeSelect },
      addApi: "Maintenance_Add",
      getApi: "Maintenance_Get",
      editApi: "Maintenance_Edit",
      delApi: "Maintenance_Del"
    };

    _this.option = {
      form: {
        title: "房态颜色",
        width: 900,
        content: [
          {
            label: "名称",
            name: "Name",
            props: {
              disabled: true
            }
          },
          {
            label: "颜色",
            slot: "mySlot"
          },
          {
            label: "排序号",
            name: "Sort"
          }
        ],
        edit: {
          infoApi: _this.apiOptions.getApi,
          submitApi: _this.apiOptions.editApi,
          onOpenAfter: res => {
            _this.color = res.Data.Value;
          },
          onSubmitBefore: values => {
            values.Value = this.color;
            values.Type = this.extendData;
            return values;
          }
        }
      },
      grid: {
        api: _this.apiOptions.api,
        params: { Type: _this.data.treeSelect },
        columns: [
          {
            title: "序号",
            width: "80px",
            align: "center",
            type: "indexcolumn"
          },
          {
            title: "名称",
            dataIndex: "Name",
            width: "150px",
            align: "center"
          },
          {
            title: "颜色",
            dataIndex: "Value",
            align: "center",
            // eslint-disable-next-line no-unused-vars
            customRender: (text, record, index) => {
              return (
                <a-avatar
                  shape="square"
                  style={{
                    background: record.Value,
                    border: "1px solid #ddd"
                  }}
                />
              );
            }
          },
          {
            title: "排序号",
            width: "120px",
            dataIndex: "Sort"
          },
          {
            title: "操作",
            dataIndex: "Id",
            width: "160px",
            key: "action",
            align: "center",
            scopedSlots: { customRender: "rowAction" }
          }
        ]
      }
    };
  },
  methods: {
    changeColor(e) {
      this.color = e;
    }
  }
};
</script>

<style></style>
